import { AfterViewInit, ElementRef, inject } from '@angular/core';
import { AfterViewChecked } from '@angular/core';
import { Directive } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { delay, distinctUntilChanged } from 'rxjs/operators';
import { MatIconModule } from "@angular/material/icon";

/**
 * Cf. PaveExplicatifComponent
 * A part besoin spécifique, il est préférable d'utiliser pave-explicatif-toggler.component,
 * celui-ci embarquant d'office l'icone bien formatée et est plus simple et plus lisible dans l'applicatif consommateur
 */
@Directive({
  selector: '[libPegasePaveExplicatifToggler]',
  exportAs: 'libPegasePaveExplicatifToggler',
  standalone: true
})
export class PaveExplicatifTogglerDirective implements AfterViewInit {
  public _elementRef = inject(ElementRef);

  private _offsetLeft: BehaviorSubject<number> = new BehaviorSubject(-1);
  public get offsetLeft$(): Observable<number> {
    return this._offsetLeft.asObservable().pipe(delay(0), distinctUntilChanged());
  }

  ngAfterViewInit(): void {
    const rect = this._elementRef.nativeElement.getBoundingClientRect();
    this._offsetLeft.next(rect.left + (rect.width / 2));
  }
}
